import React from "react";
import { Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import CustomTextField from "../../../components/forms/CustomTextField";
import {
    ArrowRightAltOutlined,
    VerifiedUserOutlined,
} from "@mui/icons-material";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import useRTK from "../../../hooks/useRTK";
import { useVerifyCompanyNameMutation } from "../../../api/registerAPI/registerAPI";
import { setCompanyName } from "../../../state/features/register/registerSlice";
import { registerSelector } from "../../../state/features/selectors";
import { colors } from "../../../assets/utils/colors";
import NextAndBackBtn from "../../../components/steppers/NextAndBackBtn";
import CustomSubmitButton1 from "../../../components/forms/buttons/CustomSubmitButton1";
import DialogLinerProgress from "../../../components/DialogLinerProgress";

// ############# Validation Schema ##############
const validationSchema = Yup.object({
    companyName: Yup.string().required("Please provide member company name"),
});

const CompanyName = ({ steps, activeStep, handleNext, handleBack }) => {
    // ############ CONST ####################
    const dispatch = useDispatch();
    const RTK = useRTK();

    // ############ Redux State ##############
    const { companyName } = useSelector(registerSelector);

    // ############# RTK ##################
    const [
        verifyCompanyName,
        { isLoading, isSuccess, isError, error, data: icnData },
    ] = useVerifyCompanyNameMutation();

    // ############# useEffect ##################
    const rtkActions = (data) => {
        dispatch(setCompanyName(data));
        handleNext();
    };
    RTK.useRTKResponse(isSuccess, isError, error, icnData, rtkActions);

    return (
        <>
            <DialogLinerProgress isLoading={isLoading} />
            <Formik
                enableReinitialize
                initialValues={{
                    companyName: companyName,
                }}
                validationSchema={validationSchema}
                onSubmit={(payload) => {
                    verifyCompanyName(payload);
                }}
            >
                {(formik) => (
                    <Grid
                        container
                        justifyContent={"center"}
                        padding={2}
                        py={{ md: 2 }}
                    >
                        <Grid item sm={11} xs={12}>
                            <Typography sx={{ fontSize: 14, mt: 2 }}>
                                Please provide your company name in order to
                                proceed
                            </Typography>
                        </Grid>
                        <Grid item sm={11} xs={12} sx={{ mb: 4 }}>
                            <CustomTextField
                                className="form-input"
                                label={`Member company name`}
                                type="text"
                                name="companyName"
                                bBottom={colors.secondary}
                            />
                        </Grid>

                        {/* ################ ACTION BUTONS ###################### */}
                        <Grid
                            item
                            sm={11}
                            xs={12}
                            sx={{
                                textAlign: "center",
                            }}
                        >
                            <CustomSubmitButton1
                                startIcon={<VerifiedUserOutlined />}
                                endIcon={<ArrowRightAltOutlined />}
                                variant={"contained"}
                                loading={isLoading}
                                onClick={() => {
                                    formik.handleSubmit();
                                }}
                            >
                                Confirm company name
                            </CustomSubmitButton1>
                        </Grid>
                        <Grid
                            item
                            sm={11}
                            xs={12}
                            sx={{
                                marginTop: 2.5,
                                textAlign: "center",
                            }}
                        >
                            <NextAndBackBtn
                                steps={steps}
                                activeStep={activeStep}
                                disabled={companyName ? false : true}
                                handleBack={handleBack}
                                action={handleNext}
                            />
                        </Grid>
                    </Grid>
                )}
            </Formik>
        </>
    );
};

export default CompanyName;
